/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react'
import MUIDataTable from 'mui-datatables'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

const MuiDataTable = (props) => {
  const [tableData, setTableData] = useState([])
  const { t } = useTranslation()

  useEffect(() => {
    if (props?.tableFor === undefined) {
      const fetchData = async () => {
        try {
          const currentData = await props.data(props.prop)
          // this is to match the data from currentData that are corresponding to the table columns
          const formattedData = currentData.map(item => {
            const newObj = {}
            props.columns.forEach(column => {
              if (column.name === 'jobType') {
                newObj[column.name] = t(`templateTypeObj.${item[column.name]}`)
              } else if (column.name === 'status') {
                newObj[column.name] = t(`jobStatusObj.${item[column.name]}`)
              } else {
                newObj[column.name] = item[column.name]
              }
            })
            return newObj
          })
          setTableData(formattedData)
        } catch (error) {
          // eslint-disable-next-line
          console.error('Error fetching data:', error)
        }
      }
      fetchData()
    }
  }, [props.prop])

  useEffect(() => {
    if (props?.tableFor === 'smart_catalog_view_requests') {
      const fetchData = async () => {
        try {
          // const currentData = await props.data(props.prop)
          const currentData = props.data
          // this is to match the data from currentData that are corresponding to the table columns
          const formattedData = currentData.map(item => {
            const newObj = {}
            props.columns.forEach(column => {
              if (column.name === 'jobType') {
                newObj[column.name] = t(`templateTypeObj.${item[column.name]}`)
              } else if (column.name === 'status') {
                newObj[column.name] = t(`jobStatusObj.${item[column.name]}`)
              } else {
                newObj[column.name] = item[column.name]
              }
            })
            return newObj
          })
          setTableData(formattedData)
        } catch (error) {
          // eslint-disable-next-line
          console.error('Error fetching data:', error)
        }
      }
      fetchData()
    }
  }, [props?.data])

  useEffect(() => {
    /*eslint-disable*/
    if (props?.tableFor === 'smart_catalog') {
      const Idata = props.data
      const newItems = Idata.map(item => {
        return {
          ...item,
          status: t(`jobStatusObj.${item.status}`)
        }
      })
      setTableData(newItems)
    }
  }, [props?.data])

  return (
    <MUIDataTable
      title={props.title}
      data={tableData}
      columns={props.columns}
      options={props.options}
      />
  )
}
  
MuiDataTable.propTypes = {
  title: PropTypes.string,
  data: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.array
  ]),
  options: PropTypes.object,
  columns: PropTypes.array,
  prop: PropTypes.object,
}

export default MuiDataTable
